import { Navigate, useRoutes } from 'react-router-dom';

// import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import About from './pages/About';
import ContactUs from './pages/ContactUs';
import Events from './pages/Events';

import DashboardAppPage from './pages/DashboardAppPage';
import Classes from './pages/Classes';
import ClassDetail from './pages/ClassDetail';
import DonateNow from './pages/DonateNow';
import Payment from './pages/Payment';
import CheckoutSuccess from './pages/CheckoutSuccess';
import EventDetail from './pages/EventDetail';
import Prayers from './pages/Prayers';
import Membership2026 from './pages/Membership2026';
import MembershipThankYou from './pages/MembershipThankYou';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import MyAccount from './pages/MyAccount';
import ResetPassword from './pages/ResetPassword';
import PayInvoice from './pages/PayInvoice';
// ----------------------------------------------------------------------

export default function Router() {
  const eventId = localStorage.getItem('eventId');
  const classId = localStorage.getItem('classId');

  const routes = useRoutes([
    {
      path: '/',
      element: <DashboardAppPage />,
      children: [
        { element: <Navigate to="/home" />, index: true },
        { path: 'home', element: <DashboardAppPage /> },
      ],
    },

    {
      // Emailed "Set up my account" lands here. The page is the homepage
      // so the real header mounts and auto-opens the Redeem modal.
      path: 'invite',
      element: <DashboardAppPage />,
    },

    {
      // Emailed "Login To My Account" lands here and auto-opens Sign in, then
      // continues to ?next= (High Holiday Seats) after they authenticate.
      path: 'signin',
      element: <DashboardAppPage />,
    },

    {
      path: 'about-us',
      element: <About />,
    },
    {
      path: 'contact-us',
      element: <ContactUs />,
    },

    {
      path: 'events',
      element: <Events />,
    },

    {
      path: `event-detail/${eventId}`,
      element: <EventDetail />,
    },

    {
      path: 'classes',
      element: <Classes />,
    },

    {
      path: 'prayers',
      element: <Prayers />,
    },

    {
      // Pre-launch membership page, retired 2026-09-02: it still sold the
      // OLD prices (e.g. Family $1,400 vs $1,512) with no household/seat
      // capture, no enrollment record and no receipt. Old links and search
      // results land on the real flow instead.
      path: 'membership',
      element: <Navigate to="/membership2026" replace />,
    },

    {
      path: 'membership2026',
      element: <Membership2026 />,
    },

    {
      path: 'membership2026/thank-you',
      element: <MembershipThankYou />,
    },

    {
      path: `class-detail/${classId}`,
      element: <ClassDetail />,
    },

    {
      path: 'donate-now',
      element: <DonateNow />,
    },

    {
      path: 'payment-checkout',
      element: <Payment />,
    },

    {
      path: 'payment-success',
      element: <CheckoutSuccess />,
    },

    {
      // Public pay-link page from the invoice email. No login.
      path: 'pay/:token',
      element: <PayInvoice />,
    },

    {
      path: 'my-account',
      element: <MyAccount />,
    },
    {
      // Emailed reset / set-password links land here instead of Firebase's
      // unbranded __/auth/action handler.
      path: 'reset-password',
      element: <ResetPassword />,
    },
    {
      path: 'privacy',
      element: <Privacy />,
    },

    {
      path: 'terms',
      element: <Terms />,
    },

    // {
    //   path: 'login',
    //   element: <LoginPage />,
    // },

    {
      // element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
